import React from 'react';

const INLINE_MARKERS = [
  { token: '**', tag: 'strong' },
  { token: '~~', tag: 's' },
  { token: '*', tag: 'em' },
];

function parseToken(text, token, tag, keyPrefix) {
  const parts = [];
  let cursor = 0;
  let index = 0;

  while (cursor < text.length) {
    const start = text.indexOf(token, cursor);
    if (start === -1) {
      parts.push(text.slice(cursor));
      break;
    }

    const end = text.indexOf(token, start + token.length);
    if (end === -1) {
      parts.push(text.slice(cursor));
      break;
    }

    if (start > cursor) {
      parts.push(text.slice(cursor, start));
    }

    const content = text.slice(start + token.length, end);
    const Tag = tag;
    parts.push(
      <Tag key={`${keyPrefix}-${token}-${index}`}>
        {renderSimpleMarkdownNodes(content, `${keyPrefix}-${token}-${index}`)}
      </Tag>
    );

    cursor = end + token.length;
    index += 1;
  }

  return parts;
}

export function renderSimpleMarkdownNodes(text, keyPrefix = 'md') {
  const source = String(text ?? '');

  const inlineNodes = INLINE_MARKERS.reduce((nodes, marker) => (
    nodes.flatMap((node, index) => {
      if (typeof node !== 'string') {
        return [node];
      }

      return parseToken(node, marker.token, marker.tag, `${keyPrefix}-${index}`);
    })
  ), [source]);

  const withLineBreaks = [];

  inlineNodes.forEach((node, index) => {
    if (typeof node !== 'string') {
      withLineBreaks.push(node);
      return;
    }

    const lines = node.split('\n');
    lines.forEach((line, lineIndex) => {
      if (line) {
        withLineBreaks.push(line);
      }

      if (lineIndex < lines.length - 1) {
        withLineBreaks.push(<br key={`${keyPrefix}-br-${index}-${lineIndex}`} />);
      }
    });
  });

  return withLineBreaks;
}

export function stripSimpleMarkdown(text) {
  return String(text ?? '').replace(/(\*\*|\*|~~)/g, '');
}
